

<style lang="css">
.found {
  color: red;
}
</style>

<template>
  <div>
    <div class="modal glossary" v-bind:class="{ 'is-active': glossaryIsActive }">
      <div class="modal-background"></div>
      <div class="modal-card" v-bind:class="{ 'is-loading': glossaryIsLoading }">
        <header class="modal-card-head">
          <p class="modal-card-title">Term: "{{glossaryTerm}}"</p>
          <button class="delete" aria-label="close" @click="glossaryIsActive = false"></button>
        </header>
        <section class="modal-card-body">
          <div v-html="glossary"></div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="glossaryIsActive = false">Close</button>
        </footer>
      </div>
    </div>
    <section class="section columns lesson-container" v-if="lesson && !lesson.is_articulate_rise_lesson">
      <div class="column is-fluid container lesson-content-container">
        <div class="lesson-title-container"></div>
        <div v-if="lesson.audios.length > 0" class="audio box">
          <audio controls :src="lesson.audios[0].url" :type="lesson.audios[0].mime_type"></audio>
        </div>
        <div v-if="lesson.video_url !== ''">
          <iframe
            type="text/html"
            class="project-note-html-video-iframe"
            width="100%"
            height="100%"
            :src="lesson.video_url"
          ></iframe>
        </div>
        <div class="content-wrapper">
          <div class="lesson-content-block box">
            <Lesson
              :template="content"
              :placeholder="lesson.content"
              @toggleGlossary="showGlossary"
            ></Lesson>
          </div>
        </div>
        <div
          class="lesson-content-block-further-reading has-text-left"
          v-if="lesson.further_reading !== ''"
        >
          <h3 class="title is-4">Further reading</h3>
          <div v-html="lesson.further_reading"></div>
        </div>
        <div
          class="lesson-content-block-further-reading has-text-left"
          v-if="lesson.facilitator_note !== '' && $store.state.auth.user.is_facilitator == true"
        >
          <h3 class="title is-4">Facilitator note</h3>
          <div v-html="lesson.facilitator_note"></div>
        </div>
        <div class="lesson-content-buttons has-text-centered">
          <router-link
            class="button gen-button"
            :to="'/courses/' + courseId + '/unit/' + unitId + '/lesson/' + lesson.previousLesson.id"
            v-if="lesson.previousLesson"
          >Previous Page</router-link>
          <a
            v-for="(lesson,x) in lesson.all"
            :key="x"
            :class="{'active':lesson.id == lessonId}"
            @click="pageNumberNavigate(lesson.id)"
            class="has-text-underlined page-link"
          >{{x +1}}</a>
          <button
            class="button gen-button"
            @click.prevent="completeLesson"
            v-if="this.lesson.all.findIndex(obj => {
            return obj.id == this.lessonId;
          }) + 1 !== this.lesson.all.length"
          >Next Page</button>
        </div>
      </div>
    </section>

    <section class="section" v-if="lesson && lesson.is_articulate_rise_lesson">
      <div class="columns">
      <div class="column">
        <vue-friendly-iframe class="frame" :src="lessonRiseUrl"></vue-friendly-iframe>
      </div>
      </div>
      <div class="columns">
        <div class="column lesson-container">

          <div
                  class="lesson-content-block-further-reading has-text-left"
                  v-if="lesson.further_reading !== ''"
          >
            <h3 class="title is-4">Further reading</h3>
            <div v-html="lesson.further_reading"></div>
          </div>
          <div
                  class="lesson-content-block-further-reading has-text-left"
                  v-if="lesson.facilitator_note !== '' && $store.state.auth.user.is_facilitator == true"
          >
            <h3 class="title is-4">Facilitator note</h3>
            <div v-html="lesson.facilitator_note"></div>
          </div>
          <div class="lesson-content-buttons has-text-centered">
            <router-link
                    class="button gen-button"
                    :to="'/courses/' + courseId + '/unit/' + unitId + '/lesson/' + lesson.previousLesson.id"
                    v-if="lesson.previousLesson"
            >Previous Page</router-link>
            <a
                    v-for="(lesson,x) in lesson.all"
                    :key="x"
                    :class="{'active':lesson.id == lessonId}"
                    @click="pageNumberNavigate(lesson.id)"
                    class="has-text-underlined page-link"
            >{{x +1}}</a>
            <button
                    class="button gen-button"
                    @click.prevent="completeLesson"
                    v-if="this.lesson.all.findIndex(obj => {
            return obj.id == this.lessonId;
          }) + 1 !== this.lesson.all.length"
            >Next Page</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import VRuntimeTemplate from "v-runtime-template";
import Lesson from "../../../components/courses/Lesson";
import { CourseClient } from "../../../clients/CourseClient";
import { mapState } from "vuex";
import {VueFriendlyIframe} from 'vue-friendly-iframe';

export default {
  props: ["courseId", "unitId", "lessonId"],
  components: { Lesson,
            'vue-friendly-iframe': VueFriendlyIframe

  },

  data() {
    return {
      lesson: null,
      content: null,
      glossary_of_terms: null,
      glossaryIsActive: false,
      glossaryIsLoading: false,
      glossary: "",
      glossaryTerm: "",
//      lessonRiseUrl: 'https://generation.ams3.cdn.digitaloceanspaces.com/rise-test/index.html'

    };
  },
  watch: {
    glossaryIsLoading: function(val, oldVal) {
      if (val == true) {
        this.glossary = "<h1>Loading...</h1>";
      }
    }
  },
  computed: {
    ...mapState({
      lessonSearchTerm(state) {
        return state.search.lessonSearchTerm;
      }
    }),
      lessonRiseUrl: function () {
          // `this` points to the vm instance
          return 'https://generation.ams3.digitaloceanspaces.com/lesson/' + this.lesson.id + '/rise/content/index.html'
//          return 'https://generation.ams3.cdn.digitaloceanspaces.com/lesson/' + this.lesson.id + '/rise/content/index.html'
      }
  },
  methods: {
    processLessonContent() {
      let output = this.content;
      if (this.lessonSearchTerm != null) {
        let highlight = new RegExp(
          "\\b(" + this.lessonSearchTerm + ")\\b",
          "gi"
        );

        output = output.replace(highlight, "<span class='highlight'>$1</span>");
        this.$store.dispatch("search/setLessonTerm", null);
        this.content = output;
      }
    },
    showGlossary: function(glossary_id, term) {
      let chosenTerm = this.glossary_of_terms.find(
        term => term.id === glossary_id
      );
      this.glossaryIsActive = true;
      this.glossaryIsLoading = true;
      this.glossaryTerm = chosenTerm.text;
      this.glossary = chosenTerm.description;
      this.glossaryIsLoading = false;

      //     this.glossaryIsLoading = false;
      // CourseClient.getGlossaryTerm(glossary_id)
      //   .then(response => {
      //     this.glossary = response.data.term.description;
      //     this.glossaryIsLoading = false;
      //   })
      //   .catch(() => {});
    },
    pageNumberNavigate(toLessonId) {
      this.$store.dispatch("loader/show", "Loading lesson....");
      CourseClient.completeLesson(this.courseId, this.unitId, this.lessonId)
        .then(response => {
          this.$store.dispatch("loader/hide");

          return this.$router.push(
            "/courses/" +
              this.courseId +
              "/unit/" +
              this.unitId +
              "/lesson/" +
              toLessonId
          );
        })
        .catch(err => {
          this.stopLoader();
          console.log(err);
        });
    },
    completeLesson: function() {
      this.$store.dispatch("loader/show", "Loading lesson....");
      CourseClient.completeLesson(this.courseId, this.unitId, this.lessonId)
        .then(response => {
          this.$store.dispatch("loader/hide");

          let currentLesson = this.lesson.all.findIndex(obj => {
            return obj.id == this.lessonId;
          });

          let nextLesson = this.lesson.all[currentLesson + 1];

          return this.$router.push(
            "/courses/" +
              this.courseId +
              "/unit/" +
              this.unitId +
              "/lesson/" +
              nextLesson.id
          );
        })
        .catch(err => {
          this.stopLoader();
          console.log(err);
        });
    },
    addHintBox: function() {
      let contentWithHintbox = this.lesson.content;
      for (let term of this.glossary_of_terms) {
        contentWithHintbox = `<div>${contentWithHintbox.replace(
          new RegExp("\\b(" + term.text + ")\\b", "gi"),
          '<span class="tooltip" @click="toggleGlossary(' +
            term.id +
            ')">$1</span>'
        )}</div>`;
      }

      this.content = contentWithHintbox;
    }
  },

  mounted() {
    this.$store.dispatch("loader/show", "Loading lesson....");
    console.log("requesting");

    CourseClient.getLesson(this.courseId, this.unitId, this.lessonId)
      .then(response => {
        this.$store.dispatch("loader/hide");
        this.lesson = response.data.lesson;
        this.glossary_of_terms = response.data.glossary_of_terms;
        this.addHintBox();
        this.processLessonContent();
      })
      .catch(err => {
        this.$store.dispatch("loader/hide");
      });
  }
};
</script>
<style lang='scss'>
@import "../../../assets/scss/variables.scss";
@import "../../../assets/scss/courses/lesson/contentVariables.scss";
@import "../../../assets/scss/courses/lesson/entry.scss";
@import "../../../assets/scss/courses/lesson/tippy-theme-genx.scss";
.frame iframe {
  width: 100%;
  height: 1000px;
}
</style>
